/* global gRootURL */

import $ from "jquery";

var hasSelStart, hasSelRange;

(function() {
	var test = document.createElement("textarea");
	hasSelStart = "selectionStart" in test;
	// IE7-8
	hasSelRange = document.selection && document.selection.createRange;
})();

function count(value, salt, start, end) {
	for(var r = 0; (start = value.indexOf(salt, start)) >= 0 && start < end; r++) {
		start += salt.length;
	}
	return r;
}

function getSel(cc) {
	var s, e, t;
	if(hasSelStart) {
		s = cc.selectionStart;
		e = cc.selectionEnd;
		t = cc.value.substring(s, e);
	} else if(hasSelRange) {
		cc.focus();
		var range = document.selection.createRange();
		var len = cc.value.length;
		var normalizedValue = cc.value.replace(/\r\n/g, "\n");
		var textInputRange = cc.createTextRange();
		textInputRange.moveToBookmark(range.getBookmark());
		var endRange = cc.createTextRange();
		endRange.collapse(false);
		if(textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
			s = e = len;
		} else {
			s = -textInputRange.moveStart("character", -len);
			s += count(normalizedValue, "\n", 0, s);
			if(textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
				e = len;
			} else {
				e = -textInputRange.moveEnd("character", -len);
				e += count(normalizedValue, "\n", 0, e);
			}
		}
		t = cc.value.substring(s, e);
	} else {
		s = 0;
		e = cc.value.length;
		t = cc.value;
	}
	return { start: s, end: e, text: t };
}

function setSel(cc, sel) {
	if(hasSelStart) {
		cc.selectionStart = sel.start;
		cc.selectionEnd = sel.end;
	} else if(hasSelRange) {
		cc.focus();
		var value = cc.value;

		var s = sel.start;
		s -= count(value, "\n", 0, s);
		var e = sel.end;
		e -= count(value, "\n", 0, e);

		var r = cc.createTextRange();
		r.collapse(true);
		r.moveStart("character", s);
		r.moveEnd("character", e - s);
		r.select();
	}
}

function replaceSel(cc, sel) {
	cc.value = cc.value.substring(0, sel.start) + sel.text + cc.value.substring(sel.end);
}

// indent each line with text
function processLines(cc, fn, count) {
	var sel = getSel(cc);
	var value = cc.value;

	var n;
	sel.start = 1 + value.lastIndexOf("\n", sel.start);
	n = value.indexOf("\n", sel.end);
	sel.end = n >= 0 ? n : value.length;

	var lines = value.substring(sel.start, sel.end).split("\n");
	if(!count  || count < 1 || count > lines.length) count = lines.length;
	for(var i = 0; i < count; i++)
		lines[i] = fn(lines[i]);

	sel.text = lines.join("\n");
	replaceSel(cc, sel);
	return sel;
}

// insert text at cursor
function insert(text) {
	/* jshint validthis: true */
	var sel = getSel(this);
	sel.text = text;
	replaceSel(this, sel);
}

// add text around selection
function wrap(prefix, suffix) {
	/* jshint validthis: true */
	suffix = suffix != null ? suffix : prefix;
	var sel = getSel(this);
	sel.text = prefix + sel.text + suffix;
	replaceSel(this, sel);
	setSel(this, { start: sel.start + prefix.length, end: sel.start + prefix.length });
}

function indent(prefix, count) {
	/* jshint validthis: true */
	var sel = processLines(this, function(line) { return (prefix || "\t") + line; }, count);
	if(prefix == null) {
		sel.end = sel.start + sel.text.length;
	} else {
		sel.end = sel.start;
	}
	setSel(this, sel);
}

function unindent(rgremove) {
	/* jshint validthis: true */
	var sel = processLines(this, function(line) { return line.replace(rgremove, ""); });
	sel.end = sel.start + sel.text.length;
	setSel(this, sel);
}

function list() {
	var n = 0;
	/* jshint validthis: true */
	var sel = processLines(this, function(line) {
		n = n + 1;
		return n + ". " + line;
	});
	sel.end = sel.start;
	setSel(this, sel);
}

var textAreaProcessors = {
	insert: insert,
	wrap: wrap,
	list: list,
	indent: indent,
	unindent: unindent,
	getValue: function(input) { return input.value; }
};

var toolbarConfig = [
	{
		"#h1": ["<b>H<small>1</small></b>", "Header 1", "indent", "# ", 1],
		"#h2": ["<b>H<small>2</small></b>", "Header 2", "indent", "## ", 1],
		"#h3": ["<b>H<small>3</small></b>", "Header 3", "indent", "### ", 1]
	},
	{
		"#strong": ["<b>B</b>", "Bold", "wrap", "**" ],
		"#em": ["<b><i>I</i></b>", "Italic", "wrap", "_"],
		"#code": ["{}", "Code" , "wrap",  "``"]
	},
	{
		"#ol": ["1.", "Numbered List", "list" ],
		"#ul": ["*", "Bulleted List", "indent", "* "],
		"#blockquote": ["&gt;", "Block Quote", "indent", "> "]
	},
	{
		"#indent": ["&raquo;", "Indent", "indent" ],
		"#unindent": ["&laquo;", "Unindent", "unindent", /^(\t|\x20{1,9})/g]
	},
	{
		"#hr": ["&mdash;", "Horizontal Line", "insert", "\r\n* * *\r\n"],
		"#a": ["<u>A</u>", "Web Link", "wrap", "[Link Label](", ")" ],
		"#img": ["[&#230;]", "Web Image", "wrap", "![Image Label](", ")"]
	}
];

function createToolbar(editor, processors, strictMarkup) {
	processors = processors || textAreaProcessors;
	var gg, t = $("<div>", { "class": "td-markuptoolbar" });
	for(var i = 0; i < toolbarConfig.length; i++) {
		var g = toolbarConfig[i];
		gg = $("<nobr>").appendTo(t);
		for(var k in g) {
			var b = g[k];
			if(typeof b !== "function") {
				$("<a>", { href: k, "class": "ui-button small", title: b[1] }).html(b[0]).appendTo(gg);
			}
		}
	}

	gg = $("<nobr>", { style: "float:right;margin-right:0" }).appendTo(t);

	var previewURL = "historytext.aspx";
	/// HACK: use abs URL
	if(/\/setup\//.test(location.pathname)) {
		previewURL = "../" + previewURL;
		if(strictMarkup)
			previewURL += "?strict=1";
	} else if(editor.name) {
		var m = editor.name.match(/^f_(\d+)(_o)?$/);
		if(m != null) {
			previewURL += "?fid=" + m[1];
		}
	}

	$("<a>", { href: "#", "class": "ui-button small", style: "width:auto",  title: "Preview" })
	.text("Preview")
	.on("click", function() {
		var f = $("<form>", { action: previewURL, method: "post", target: "preview" })
		.append($("<input>", { type: "hidden", name: "text", value: processors.getValue(editor) }))
		.appendTo(document.body);
		f[0].submit();
		f.remove();
		return false;
	})
	.appendTo(gg);

	$("<a>", { href: gRootURL + "/html/markuphelp.htm", target: "_markuphelp", "data-popup": "width=800,height=600,scrollbars=1,resizable=1,location=0,menubar=0,status=0,toolbar=0", "class": "ui-button small", title: "Help" })
	.text("?")
	.appendTo(gg);

	return t.on("click", "a[href^=\"#\"]", function(e) {
		var href = $(this).attr("href");
		for(var i = 0; i < toolbarConfig.length; i++) {
			var b = toolbarConfig[i][href];
			if(b) {
				processors[b[2]].apply(editor, b.slice(3));
				editor.focus();
				e.preventDefault();
				break;
			}
		}
	});
}

$.fn.markuptoolbar = function() {
	return this.each(function() {
		var p = $(this);
		if(p.hasClass("ui-resizable")) p = p.parent();
		if(!p.prev("div.td-markuptoolbar").length)
			p.before(createToolbar(this));
	});
};

function initMarkupToolbars(ctx) {
	$("textarea.td-markup", ctx).markuptoolbar();
}

export { createToolbar as createMarkupToolbar, initMarkupToolbars };
